import { get } from 'lodash'
import { rowActions } from 'pages/Administration/constants'
import { onExportDataOutput } from 'pages/Administration/helpers'

export const outputRoutesSelector = ({ outputConfigRoutes }) =>
  get(outputConfigRoutes, 'children', [])

export const getRowData = (data) =>
  data.map(({ roleName, permissions }) => ({
    id: roleName,
    roleName,
    permissions
  }))

export const buildTableActions = ({
  t,
  gridApi,
  columnApi,
  onAdd,
  onDelete
}) => ({
  selected: [
    {
      title: t(rowActions.delete),
      handleClick: onDelete
    }
  ],
  empty: [
    {
      title: t(rowActions.export),
      handleClick: () => {
        onExportDataOutput(gridApi, columnApi, t('OutputManagement.Title'), t)
      }
    },
    {
      title: t(rowActions.add),
      handleClick: onAdd
    }
  ]
})
